import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const TopStatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const MetricCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px 16px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  font-weight: ${vimovaTheme.fontWeights.normal};
  color: ${vimovaTheme.colors.textLight};
  margin: 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 26px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 8px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 26px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricSubtext = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${({ $color }) => $color || vimovaTheme.colors.textMuted};
  margin-top: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const ChartCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 16px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DonutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 180px !important;
  }
`

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;

  @media print {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 12px !important;
    margin-top: 12px !important;
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
  }
`

export const LegendDot = styled.div<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
  flex-shrink: 0;

  @media print {
    width: 10px !important;
    height: 10px !important;
    border-radius: 2px !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const LegendText = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.text};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarChartWrapper = styled.div`
  display: flex;
  gap: 8px;
  height: 190px;
  margin-top: auto;

  @media print {
    display: flex !important;
    gap: 8px !important;
    height: 190px !important;
    margin-top: auto !important;
  }
`

export const YAxisLabels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 150px;
  flex-shrink: 0;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    height: 150px !important;
  }
`

export const YAxisTick = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textMuted};
  text-align: right;
  min-width: 28px;

  @media print {
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarChartArea = styled.div`
  flex: 1;
  position: relative;
  height: 190px;

  @media print {
    flex: 1 !important;
    position: relative !important;
    height: 190px !important;
  }
`

export const GridLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  pointer-events: none;

  @media print {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 150px !important;
  }
`

export const GridLine = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: ${vimovaTheme.colors.border};

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarChartContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 190px;
  padding-top: 0;
  position: relative;

  @media print {
    display: flex !important;
    align-items: flex-end !important;
    gap: 6px !important;
    height: 190px !important;
  }
`

export const BarColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 4px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    flex: 1 !important;
    gap: 4px !important;
  }
`

export const Bar = styled.div<{ $height: number; $color: string }>`
  width: 100%;
  max-width: 24px;
  height: ${({ $height }) => $height}px;
  background: ${({ $color }) => $color};
  border-radius: 2px;

  @media print {
    width: 100% !important;
    max-width: 24px !important;
    height: ${({ $height }) => $height}px !important;
    background: ${({ $color }) => $color} !important;
    border-radius: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textMuted};
  text-align: center;

  @media print {
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BottomRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const InfoCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const InfoCardTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 8px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Divider = styled.div`
  height: 1px;
  background: ${vimovaTheme.colors.border};
  margin: 8px 0;

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    margin: 8px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
`

export const InfoLabel = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const InfoValue = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.xlarge};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.xlarge} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const InfoValueUnit = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};
  margin-left: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarContainer = styled.div`
  margin-top: 8px;

  @media print {
    margin-top: 8px !important;
  }
`

export const ProgressBarTrack = styled.div`
  height: 6px;
  border-radius: 3px;
  background: ${vimovaTheme.colors.backgroundMuted};
  margin-top: 8px;

  @media print {
    height: 6px !important;
    border-radius: 3px !important;
    background: ${vimovaTheme.colors.backgroundMuted} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarFill = styled.div<{ $width: number; $color: string }>`
  height: 6px;
  border-radius: 3px;
  background: ${({ $color }) => $color};
  width: ${({ $width }) => $width}%;

  @media print {
    height: 6px !important;
    border-radius: 3px !important;
    background: ${({ $color }) => $color} !important;
    width: ${({ $width }) => $width}% !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }
`

export const ProgressBarLabelText = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarValueText = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
